import { combineReducers } from "@reduxjs/toolkit";
import manageFolderApi from "../apis/manage-folder";
import manageSaveSearchApi from "../apis/manage-save-search";
import manageFolderFilterSlice from "./manageFolderFilterSlice/manageFolderFilterSlice";
import manageSaveSearchFilterSlice from "./manageSaveSearchFilterSlice/manageSaveSearchFilterSlice";
import recruiterDetailsSlice from "./recruiterDetails/recruiterDetailsSlice";
import loginApi from "../apis/login";
import masterDataSlice from "./masterDataFilterSlice/masterDataFilterSlice";
// import masterDataApi from "../apis/get-master-data";
import folderManagementApi from "../apis/folder-management";
import filterFormValuesSlice from "./filterFormValuesSlice/filterFormValuesSlice";
import folderManagementFilterSlice from "./folderManagementFilterSlice/folderManagementFilterSlice";
import loginSlice from "./loginSlice";

const rootReducer = combineReducers({
  // add reducers here ...
  [manageFolderApi.reducerPath]: manageFolderApi.reducer,
  [manageFolderFilterSlice.name]: manageFolderFilterSlice.reducer,
  [folderManagementApi.reducerPath]: folderManagementApi.reducer,
  [manageSaveSearchApi.reducerPath]: manageSaveSearchApi.reducer,
  [manageSaveSearchFilterSlice.name]: manageSaveSearchFilterSlice.reducer,
  [folderManagementFilterSlice.name]: folderManagementFilterSlice.reducer,
  [loginApi.reducerPath]: loginApi.reducer,
  [recruiterDetailsSlice.name]: recruiterDetailsSlice.reducer,
  // [masterDataApi.reducerPath]: masterDataApi.reducer,
  [masterDataSlice.name]: masterDataSlice.reducer,
  [filterFormValuesSlice.name]: filterFormValuesSlice.reducer,
  [loginSlice.name]:loginSlice.reducer
});

// export const reduxMiddlewares = [
//     // add middlewares here ...
//     manageFolderApi.middleware,
//     folderManagementApi.middleware,
//     manageSaveSearchApi.middleware,
//     loginApi.middleware,
//     masterDataApi.middleware,
// ]

export default rootReducer;
